import { useEffect, useMemo, useState } from 'react'

import { SportCategoryType } from '@sportworld/js-sdk/src/types/servicesTypes/sportCategoriesTypes'

import { getTileProps } from '@/components/Lines/utils'
import { LineTileShape, LineTileSize } from '@/constants/common'
import { ApiService } from '@/service'
import { findBestImage } from '@/utils/utils'

type ViewMoreImageProps = {
  tileShape?: LineTileShape
  tileSize?: LineTileSize
  categoryId?: string
}

export const useViewMoreImage = ({
  tileShape,
  tileSize,
  categoryId,
}: ViewMoreImageProps) => {
  const [category, setCategory] = useState<Nullable<SportCategoryType>>(null)

  const imgUrl = useMemo(
    () =>
      findBestImage(category?.image?.sources, {
        targetWidth: getTileProps(tileShape, tileSize).w,
        targetShape: tileShape,
      })?.url,
    [category?.id, tileShape, tileSize],
  )

  useEffect(() => {
    const controller = new AbortController()
    const abortSignal = controller.signal

    if (categoryId) {
      ApiService.getSportCategoryById(categoryId, abortSignal)
        .then((res) => {
          if (!controller.signal.aborted) {
            setCategory(res)
          }
        })
        .catch(() => {
          setCategory(null)
        })
    } else {
      setCategory(null)
    }

    return () => {
      controller.abort()
    }
  }, [categoryId])

  return imgUrl
}
